import * as React from 'react';
function defaultPropsMergeFn(ownProps, props) {
  return {
    ...ownProps,
    ...props
  };
}
export default function withProps(_children, props, propsMergeFn = defaultPropsMergeFn) {
  try {
    const children = React.Children.only(_children);
    const ownProps = /*#__PURE__*/React.isValidElement(children) && typeof (children == null ? void 0 : children.props) === 'object' ? children.props : {};
    return /*#__PURE__*/React.cloneElement(children, propsMergeFn(ownProps, props));
  } catch (e) {
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
      // eslint-disable-next-line no-console
      console.error('@ovpn-ui/core: Component might not work as intended. Expected single child\n\n', e);
    }
    return _children;
  }
}